import { render, staticRenderFns } from "./x.vue?vue&type=template&id=8b8f8ffa"
import script from "./x.vue?vue&type=script&lang=js"
export * from "./x.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports